function getPriceString(result, currencySymbol, localisations) {
  let price = '';
  const minRent = result.equivalent_room_price_from || result.min_rent || '';
  const maxRent = result.equivalent_room_price_to || result.max_rent || '';
  const billsInc =
    result.bills_inc === 'Yes' ? `${localisations.inc_bills}` : '';

  price = minRent || '';
  price += `${maxRent ? `-${maxRent}` : ''} ${
    result.per === 'pcm' ? localisations.pcm : localisations.pw
  }`;

  if (result.rent_options === 'whole' && result.rooms_in_property > 1) {
    price = `${result.min_rent || result.max_rent} ${result.per} (${
      localisations.eqv_to
    } ${price}${billsInc ? `, ${billsInc}` : ''})`;
  } else {
    price += billsInc ? ` (${billsInc})` : '';
  }

  return currencySymbol + price;
}

function processResult(
  result,
  {
    offeredDetailUrl = '/flatshare/flatshare_detail.pl',
    currencySymbol = '£',
    searchResults,
  } = {},
  localisations,
) {
  result.ad_title = result.ad_title || 'Untitled';
  result.accom_type = result.accom_type || result.room_size || '';
  result.listing_url = `${offeredDetailUrl}?flatshare_id=${
    result.advert_id
  }&search_results=${encodeURIComponent(`${searchResults}`)}`;
  result.price = getPriceString(result, currencySymbol, localisations);
  return result;
}

function processResults(newResults, config, localisations) {
  const processedResults = newResults.map((result) =>
    processResult(result, config, localisations),
  );
  return processedResults;
}

export default processResults;
